// extracted by mini-css-extract-plugin
module.exports =  {"root":"SsRceIjJwKSLlNuFLowI","suppressGap":"YV0iaEKgWx4O3CdDQYkc"};